var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorExclamationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.825 0 0 3.825 0 8.5C0 13.175 3.825 17 8.5 17C13.175 17 17 13.175 17 8.5C17 3.825 13.175 0 8.5 0ZM9.35 13.4725C9.095 13.685 8.7975 13.8125 8.4575 13.8125C8.075 13.8125 7.82 13.685 7.6075 13.4725C7.3525 13.2175 7.225 12.8775 7.225 12.5375C7.225 12.1125 7.3525 11.815 7.6075 11.56C7.8625 11.3475 8.16 11.2625 8.4575 11.2625C8.84 11.2625 9.1375 11.39 9.3925 11.645C9.605 11.8575 9.69 12.155 9.7325 12.5375C9.7325 12.92 9.605 13.2175 9.35 13.4725ZM9.52 5.865C9.3075 6.715 9.095 8.16 8.8825 10.2H8.075C7.82 8.16 7.6075 6.715 7.395 5.865C7.1825 5.1 7.055 4.59 7.055 4.3775C7.055 4.0375 7.1825 3.6975 7.395 3.4425C7.65 3.1875 7.99 3.0175 8.5 3.0175C8.925 3.0175 9.2225 3.1875 9.4775 3.4425C9.69 3.6975 9.8175 3.995 9.8175 4.3775C9.8175 4.59 9.7325 5.1 9.52 5.865Z",
    fill: "#F38D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamationPoint);
export default __webpack_public_path__ + "static/media/error-exclamation-point.a0e213105c1220c718cb8b88c367e21d.svg";
export { ForwardRef as ReactComponent };